import { Loader2Icon } from "lucide-react"

import { cn } from "@/lib/utils"
import { t } from "@workspace/strings/web"

function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <Loader2Icon
      role="status"
      aria-label={t("nav.ui.loading")}
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  )
}

export { Spinner }
